/**
 * BQB Reorganize - MyPureSkin Custom Layout
 * 
 * Réorganise le widget BQB pour afficher :
 * 1. Les abonnements (subscriptions) en haut
 * 2. Le bouton Add to Cart
 * 3. Les avantages de l'abonnement
 * 4. Un lien "Buy once for $X + shipping" qui déplie les options one-time
 */

(function() {
  'use strict';

  // Configuration - Modifiez ces valeurs selon vos besoins
  const CONFIG = {
    sectionTitle: 'Choose your option:',
    oneTimePrice: '$190', // Prix unitaire achat unique (sera mis à jour dynamiquement)
    shippingCost: '$6.95',
    subscriptionBenefits: [
      { icon: 'users', text: 'Guided by our scientific committee' },
      { icon: 'package', text: 'Free shipping from our US Offices' },
      { icon: 'heart', text: 'A Headspace subscription' },
      { icon: 'x-circle', text: 'Cancel subscription anytime' }
    ],
    subscriptionMention: 'Free shipping. Pause or cancel anytime.',
    recommendText: 'We recommend 3-6 months of consistent use to see results'
  };

  // Lucide-style SVG icons (simplified)
  const ICONS = {
    'user-check': '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><polyline points="16 11 18 13 22 9"/></svg>',
    'users': '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    'package': '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>',
    'heart': '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>',
    'x-circle': '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>'
  };

  function getProductContext() {
    const metaProduct = window.meta && window.meta.product ? window.meta.product : null;
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const fallbackHandle = pathParts[0] === 'products' ? pathParts[1] : '';
    return {
      product_id: metaProduct && metaProduct.id ? String(metaProduct.id) : '',
      product_handle: metaProduct && metaProduct.handle ? metaProduct.handle : fallbackHandle
    };
  }

  function getSelectionMode(input) {
    if (!input) return 'unknown';
    if (input.closest('.bqb-subscriptions-wrapper')) return 'subscription';
    if (input.closest('.bqb-onetime-content')) return 'onetime';
    return 'unknown';
  }

  function getBqbChoiceInputs(scope = document) {
    return scope.querySelectorAll(
      '.bqb-subscriptions-wrapper input[type="radio"], .bqb-onetime-content input[type="radio"]'
    );
  }

  function getPriceText(level, selector) {
    if (!level) return '';
    const el = level.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function isThreeMonthSubscription(level) {
    if (!level) return false;
    const titleText = getPriceText(level, '.bqb-title').toLowerCase();
    const subtitleText = getPriceText(level, '.bqb-subtitle').toLowerCase();

    return /3\s*month/.test(titleText) ||
      /3\s*month/.test(subtitleText) ||
      /12\s*week/.test(subtitleText);
  }

  function trackBqbEvent(eventName, payload) {
    const eventPayload = {
      event: eventName,
      ...getProductContext(),
      ...payload,
      timestamp: Date.now()
    };

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(eventPayload);
    }

    window.dispatchEvent(new CustomEvent(`bqb:${eventName}`, { detail: eventPayload }));
  }

  function setupAddToCartTracking(bqbUI) {
    const bqbScope = bqbUI.closest('.shopify-section, main, .main-content') || document;
    const forms = bqbScope.querySelectorAll('form[action*="/cart/add"]');
    if (!window.__bqbPendingAtcPayload) {
      window.__bqbPendingAtcPayload = null;
    }

    forms.forEach((form) => {
      if (form.dataset.bqbAtcTrackingBound === 'true') return;
      form.dataset.bqbAtcTrackingBound = 'true';

      form.addEventListener('submit', (event) => {
        // Anti double-submit: évite les rafales /cart/add (429 + JSON parse error)
        const now = Date.now();
        const lastSubmitAt = parseInt(form.dataset.bqbLastSubmitAt || '0', 10);
        if (lastSubmitAt && (now - lastSubmitAt) < 1200) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        form.dataset.bqbLastSubmitAt = String(now);

        const selectedInput = bqbScope.querySelector(
          '.bqb-subscriptions-wrapper input[type="radio"]:checked, .bqb-onetime-content input[type="radio"]:checked'
        );
        if (!selectedInput) return;
        const level = selectedInput.closest('.bqb-level');
        const mode = getSelectionMode(selectedInput);
        const planId = mode === 'subscription' ? String(selectedInput.value || '') : '';
        const payload = {
          mode,
          selling_plan_id: planId,
          quantity: level ? getQuantityFromLevel(level) : 1,
          title: level ? getPriceText(level, '.bqb-title span') : '',
          price: level ? getPriceText(level, '.bqb-price > span:first-child') : '',
          signal: 'form_submit'
        };

        window.__bqbPendingAtcPayload = {
          ...payload,
          pending_since: Date.now()
        };

        trackBqbEvent('add_to_cart_submit', payload);
      });
    });

    // Promouvoir en "success" uniquement quand le panier notifie une mise à jour
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      if (!window.__bqbCartSuccessTrackingBound) {
        window.__bqbCartSuccessTrackingBound = true;
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function() {
          if (!window.__bqbPendingAtcPayload) return;
          const ageMs = Date.now() - window.__bqbPendingAtcPayload.pending_since;
          if (ageMs > 10000) {
            window.__bqbPendingAtcPayload = null;
            return;
          }

          const successPayload = {
            ...window.__bqbPendingAtcPayload,
            signal: 'pubsub_cart_update'
          };
          delete successPayload.pending_since;
          trackBqbEvent('add_to_cart_success', successPayload);
          window.__bqbPendingAtcPayload = null;
        });
      }
      return;
    }

    // Fallback si pub/sub indisponible: on garde un "success" best effort
    forms.forEach((form) => {
      if (form.dataset.bqbAtcFallbackBound === 'true') return;
      form.dataset.bqbAtcFallbackBound = 'true';
      form.addEventListener('submit', () => {
        if (!window.__bqbPendingAtcPayload) return;
        const fallbackPayload = { ...window.__bqbPendingAtcPayload };
        delete fallbackPayload.pending_since;
        trackBqbEvent('add_to_cart_success', {
          ...fallbackPayload,
          signal: 'form_submit_fallback'
        });
        window.__bqbPendingAtcPayload = null;
      });
    });
  }

  // Attendre que le DOM et BQB soient chargés
  function init() {
    const bqbUI = document.querySelector('.bqb-ui');
    if (!bqbUI) {
      // Observer pour attendre que BQB soit injecté
      const observer = new MutationObserver((mutations, obs) => {
        const bqb = document.querySelector('.bqb-ui');
        if (bqb && bqb.querySelectorAll('.bqb-level').length > 0) {
          obs.disconnect();
          // Petit délai pour s'assurer que tout est rendu
          setTimeout(() => reorganizeBQB(bqb), 100);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
      return;
    }
    
    // Si BQB existe déjà mais n'a pas encore de niveaux, attendre
    if (bqbUI.querySelectorAll('.bqb-level').length === 0) {
      const observer = new MutationObserver((mutations, obs) => {
        if (bqbUI.querySelectorAll('.bqb-level').length > 0) {
          obs.disconnect();
          setTimeout(() => reorganizeBQB(bqbUI), 100);
        }
      });
      observer.observe(bqbUI, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
      return;
    }
    
    reorganizeBQB(bqbUI);
  }

  function reorganizeBQB(bqbUI) {
    // Éviter la double exécution
    if (bqbUI.dataset.reorganized === 'true') return;
    bqbUI.dataset.reorganized = 'true';

    // Récupérer tous les niveaux
    const allLevels = Array.from(bqbUI.querySelectorAll('.bqb-level'));
    
    if (allLevels.length === 0) {
      console.warn('BQB Reorganize: Aucun niveau trouvé');
      return;
    }
    
    // Séparer subscriptions et one-time basé sur:
    // 1. La valeur de l'input (selling plan ID > 1000 = subscription)
    // 2. Le contenu texte (week, month, subscription = subscription)
    const subscriptions = [];
    const oneTime = [];

    allLevels.forEach(level => {
      const input = level.querySelector('input[type="radio"]');
      const value = input ? input.value : '';
      const subtitle = level.querySelector('.bqb-subtitle');
      const subtitleText = subtitle ? subtitle.textContent.toLowerCase() : '';
      const title = level.querySelector('.bqb-title');
      const titleText = title ? title.textContent.toLowerCase() : '';
      
      // Détecter le type
      const isSubscription = 
        // Selling plan IDs sont des grands nombres
        (value && !isNaN(value) && parseInt(value) > 1000) ||
        // Ou le texte mentionne une récurrence
        subtitleText.includes('week') || 
        subtitleText.includes('month') || 
        titleText.includes('subscription') ||
        titleText.includes('month subscription');
      
      if (isSubscription) {
        subscriptions.push(level);
      } else {
        oneTime.push(level);
      }
    });

    // Prioriser l'offre "3 months subscription" en première position
    // => elle sera aussi auto-sélectionnée par la logique existante
    const threeMonthIndex = subscriptions.findIndex(level => isThreeMonthSubscription(level));
    if (threeMonthIndex > 0) {
      const [threeMonthLevel] = subscriptions.splice(threeMonthIndex, 1);
      subscriptions.unshift(threeMonthLevel);
    }

    // Récupérer le prix one-time le plus bas
    let oneTimePrice = CONFIG.oneTimePrice;
    if (oneTime.length > 0) {
      const firstOneTimePrice = oneTime[0].querySelector('.bqb-price > span:first-child');
      if (firstOneTimePrice) {
        // Extraire juste le prix sans la devise
        const priceText = firstOneTimePrice.textContent.trim();
        const priceMatch = priceText.match(/\$[\d,.]+/);
        if (priceMatch) {
          oneTimePrice = priceMatch[0];
        }
      }
    }

    // Ajouter les badges aux subscriptions
    addBadgesToSubscriptions(subscriptions);

    // Plans "N boxes" : prix par boîte + total explicite (après le calcul du Save X%)
    addPerBoxPricing(subscriptions);

    // Vider le conteneur BQB
    bqbUI.innerHTML = '';
    bqbUI.classList.add('bqb-ui--reorganized');

    // Ajouter le titre de section
    const sectionTitle = document.createElement('div');
    sectionTitle.className = 'bqb-section-title';
    sectionTitle.textContent = CONFIG.sectionTitle;
    bqbUI.appendChild(sectionTitle);

    // Créer le wrapper des subscriptions
    const subsWrapper = document.createElement('div');
    subsWrapper.className = 'bqb-subscriptions-wrapper';
    
    subscriptions.forEach((level, index) => {
      // Sélectionner la première subscription par défaut
      const input = level.querySelector('input[type="radio"]');
      if (index === 0 && input) {
        input.checked = true;
        level.classList.add('is-selected'); // Fallback pour navigateurs sans :has()
        
        // Déclencher le onchange natif de l'input pour que BQB mette à jour le selling plan
        // Utiliser un délai pour s'assurer que les fonctions BQB sont prêtes
        setTimeout(() => {
          try {
            // Déclencher le handler onchange natif défini par BQB
            if (input.onchange) {
              input.onchange({ target: input });
            }
            // Fallback: appeler les fonctions BQB directement
            if (typeof window.bqb_updateQuantity === 'function') {
              const quantity = getQuantityFromLevel(level);
              window.bqb_updateQuantity(quantity);
            }
            if (typeof window.bqb_updateSellingPlan === 'function') {
              window.bqb_updateSellingPlan(input.value);
            }
          } catch (e) {
            console.warn('BQB Reorganize: BQB functions not ready yet', e.message);
          }
        }, 200);
      }
      subsWrapper.appendChild(level);
    });
    
    bqbUI.appendChild(subsWrapper);

    // Tracking add-to-cart
    setupAddToCartTracking(bqbUI);

    // Créer la section des avantages subscription
    const benefitsSection = createBenefitsSection();
    
    // Trouver le bouton Add to Cart et insérer les éléments après
    const insertionScope = bqbUI.closest('.product-form-wrapper, .product__info-wrapper, .shopify-section, main') || document;
    
    // Créer la section one-time avec toggle
    const oneTimeSection = createOneTimeSection(oneTime, oneTimePrice);

    // Trouver le bouton Add to Cart
    const buyButtonsDiv = insertionScope.querySelector('.product-form__buttons') ||
                          insertionScope.querySelector('.buy-buttons');
    
    if (buyButtonsDiv) {
      // Insérer benefitsSection AVANT le bouton Add to Cart
      buyButtonsDiv.parentNode.insertBefore(benefitsSection, buyButtonsDiv);
      // Insérer oneTimeSection APRÈS le bouton Add to Cart
      buyButtonsDiv.parentNode.insertBefore(oneTimeSection, buyButtonsDiv.nextSibling);
    } else {
      // Fallback: insérer après le BQB
      bqbUI.appendChild(benefitsSection);
      bqbUI.appendChild(oneTimeSection);
    }

    // Décocher les options one-time par défaut (checked property + attribute)
    oneTime.forEach(level => {
      const input = level.querySelector('input[type="radio"]');
      if (input) {
        input.checked = false;
        input.removeAttribute('checked');
      }
    });

    // Sécurité: garantir une subscription sélectionnée par défaut
    const selectedSubscription = subsWrapper.querySelector('input[type="radio"]:checked');
    if (!selectedSubscription) {
      const firstSubscription = subsWrapper.querySelector('input[type="radio"]');
      if (firstSubscription) {
        firstSubscription.checked = true;
        const selectedLevel = firstSubscription.closest('.bqb-level');
        if (selectedLevel) selectedLevel.classList.add('is-selected');
      }
    }

    // Écouteurs + synchronisation visuelle finale (après insertion one-time)
    setupSelectionListeners();

    // Uniformiser l'affichage des prix: conserver USD, retirer les .00
    normalizeDisplayedPrices();
  }

  function getQuantityFromLevel(level) {
    const subtitle = level.querySelector('.bqb-subtitle');
    if (subtitle) {
      const text = subtitle.textContent;
      const match = text.match(/(\d+)\s*box/i);
      if (match) return parseInt(match[1]);
    }
    // Fallback: essayer depuis le titre
    const title = level.querySelector('.bqb-title span');
    if (title) {
      const text = title.textContent;
      const match = text.match(/(\d+)/);
      if (match) return parseInt(match[1]);
    }
    return 1;
  }

  /**
   * Configure les écouteurs pour mettre à jour la classe .is-selected
   * Fallback pour les navigateurs qui ne supportent pas :has()
   */
  function setupSelectionListeners() {
    function syncSelectedStates(preferredInput) {
      const selector = '.bqb-subscriptions-wrapper .bqb-level, .bqb-onetime-content .bqb-level';
      const inputs = Array.from(getBqbChoiceInputs(document));
      let checkedInputs = inputs.filter((input) => input.checked);

      // Garde-fou: si plusieurs radios sont cochés, on garde uniquement le dernier choisi
      if (checkedInputs.length > 1) {
        const keepInput = preferredInput && preferredInput.checked ? preferredInput : checkedInputs[checkedInputs.length - 1];
        checkedInputs.forEach((input) => {
          if (input !== keepInput) input.checked = false;
        });
        checkedInputs = [keepInput];
      }

      document.querySelectorAll(selector).forEach((level) => level.classList.remove('is-selected'));
      const activeInput = checkedInputs[0];
      if (activeInput) {
        const activeLevel = activeInput.closest('.bqb-level');
        if (activeLevel) activeLevel.classList.add('is-selected');
      }
      return activeInput || null;
    }

    // Synchronisation immédiate au chargement
    syncSelectedStates(null);

    // Délégation: couvre aussi les éléments ajoutés/déplacés dynamiquement
    if (document.documentElement.dataset.bqbSelectionDelegatedBound === 'true') return;
    document.documentElement.dataset.bqbSelectionDelegatedBound = 'true';

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.matches('.bqb-subscriptions-wrapper input[type="radio"], .bqb-onetime-content input[type="radio"]')) return;

      const activeInput = syncSelectedStates(input);
      if (!activeInput || activeInput !== input) return;

      const parentLevel = input.closest('.bqb-level');
      const mode = getSelectionMode(input);
      if (mode !== 'onetime' && mode !== 'subscription') return;
      const eventName = mode === 'onetime' ? 'onetime_selected' : 'subscription_selected';
      trackBqbEvent(eventName, {
        mode,
        selling_plan_id: mode === 'subscription' ? String(input.value || '') : '',
        quantity: parentLevel ? getQuantityFromLevel(parentLevel) : 1,
        title: parentLevel ? getPriceText(parentLevel, '.bqb-title span') : '',
        price: parentLevel ? getPriceText(parentLevel, '.bqb-price > span:first-child') : '',
        original_price: parentLevel ? getPriceText(parentLevel, '.bqb-original') : ''
      });
    });
  }

  /**
   * Ajoute les badges "Clinically recommended" et "Save X%" aux subscriptions
   * + la mention "Free shipping. Pause or cancel anytime."
   */
  function addBadgesToSubscriptions(subscriptions) {
    subscriptions.forEach((level) => {
      const titlesDiv = level.querySelector('.bqb-titles');
      const title = level.querySelector('.bqb-title');
      const subtitle = level.querySelector('.bqb-subtitle');
      const originalPrice = level.querySelector('.bqb-original');
      const currentPrice = level.querySelector('.bqb-price > span:first-child');
      
      if (!titlesDiv) return;
      
      // Calculer le pourcentage de réduction
      let savePercent = 0;
      if (originalPrice && currentPrice) {
        const original = parseFloat(originalPrice.textContent.replace(/[^0-9.]/g, ''));
        const current = parseFloat(currentPrice.textContent.replace(/[^0-9.]/g, ''));
        if (original > 0 && current > 0) {
          savePercent = Math.round(((original - current) / original) * 100);
        }
      }

      // Créer le conteneur de badges en haut de la carte
      const label = level.querySelector('label');
      let topRow = null;
      
      // Badge "Clinically recommended" (option 3 mois uniquement)
      const hasRecommendedBadge = isThreeMonthSubscription(level);
      if (hasRecommendedBadge && label) {
        topRow = document.createElement('div');
        topRow.className = 'bqb-level-top';
        const recommendedBadge = document.createElement('span');
        recommendedBadge.className = 'bqb-badge bqb-badge--recommended';
        recommendedBadge.textContent = 'Clinically recommended';
        topRow.appendChild(recommendedBadge);
        label.insertBefore(topRow, label.firstChild);
        level.classList.add('has-top-badge');
        level.classList.add('has-recommended-badge');
      }

      // Badge Save X% : ajouter au conteneur de badges (ou en créer un)
      if (savePercent > 0 && label) {
        const saveBadge = document.createElement('span');
        saveBadge.className = 'bqb-badge bqb-badge--save';
        saveBadge.textContent = `Save ${savePercent}%`;

        // Sans badge recommandé: badge SAVE inline dans le titre
        if (!hasRecommendedBadge && title) {
          saveBadge.classList.add('bqb-badge--save-inline');
          title.appendChild(saveBadge);
          level.classList.remove('has-top-badge');
        } else {
          // Mobile + cartes avec badge recommandé: badge en haut dans .bqb-level-top
          if (!topRow) {
            topRow = document.createElement('div');
            topRow.className = 'bqb-level-top';
            label.insertBefore(topRow, label.firstChild);
          }
          level.classList.add('has-top-badge');
          topRow.appendChild(saveBadge);

          // Carte avec badge recommandé:
          // ajouter aussi une version inline pour desktop (mobile la masque en CSS)
          if (hasRecommendedBadge && title) {
            const saveBadgeInline = document.createElement('span');
            saveBadgeInline.className = 'bqb-badge bqb-badge--save bqb-badge--save-inline';
            saveBadgeInline.textContent = `Save ${savePercent}%`;
            title.appendChild(saveBadgeInline);
          }
        }
      }
      
      // Conteneur pour le sous-titre uniquement
      if (subtitle) {
        const subtitleRow = document.createElement('div');
        subtitleRow.className = 'bqb-subtitle-row';
        subtitleRow.appendChild(subtitle.cloneNode(true));
        subtitle.parentNode.replaceChild(subtitleRow, subtitle);
      }

      // Ajouter la mention "Free shipping. Pause or cancel anytime."
      const mention = document.createElement('div');
      mention.className = 'bqb-subscription-mention';
      mention.textContent = CONFIG.subscriptionMention;
      titlesDiv.appendChild(mention);
    });
  }

  /**
   * Plans "N boxes every …" (N > 1) : le prix du selling plan est un prix par boîte.
   * Affiche "$164/box" + "$492 every 12 weeks" pour que le total facturé soit clair.
   */
  function addPerBoxPricing(subscriptions) {
    subscriptions.forEach((level) => {
      const subtitle = level.querySelector('.bqb-subtitle');
      const priceEl = level.querySelector('.bqb-price > span:first-child');
      if (!subtitle || !priceEl) return;

      const boxesMatch = subtitle.textContent.match(/(\d+)\s*box/i);
      const boxes = boxesMatch ? parseInt(boxesMatch[1], 10) : 0;
      const unitPrice = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
      if (boxes < 2 || !(unitPrice > 0)) return;

      const cadenceMatch = subtitle.textContent.match(/every\s+[^,.]+/i);
      const total = document.createElement('span');
      total.className = 'bqb-price-total';
      total.textContent = `${formatUsd(unitPrice * boxes)} ${cadenceMatch ? cadenceMatch[0].trim() : 'total'}`;

      priceEl.textContent = `${formatUsd(unitPrice)}/box`;
      priceEl.parentNode.appendChild(total);
    });
  }

  function formatUsd(amount) {
    const value = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return formatMoneyDisplay(`$${value}`);
  }

  function createBenefitsSection() {
    const section = document.createElement('div');
    section.className = 'bqb-subscription-benefits';
    section.innerHTML = `
      <div class="bqb-subscription-benefits__title">Your subscription includes:</div>
      <ul class="bqb-subscription-benefits__list">
        ${CONFIG.subscriptionBenefits.map(b => `<li><span class="bqb-benefit-icon">${ICONS[b.icon] || ''}</span>${b.text}</li>`).join('')}
      </ul>
    `;
    return section;
  }

  function createOneTimeSection(oneTimeLevels, price) {
    const section = document.createElement('div');
    section.className = 'bqb-onetime-wrapper';
    
    // Toggle link
    const toggle = document.createElement('div');
    toggle.className = 'bqb-onetime-toggle';
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = `
      <span class="bqb-onetime-toggle__text">Buy once for ${formatMoneyDisplay(price)}.</span>
    `;
    
    // Subtext
    const subtext = document.createElement('div');
    subtext.className = 'bqb-onetime-toggle__subtext';
    subtext.textContent = CONFIG.recommendText;
    
    // Content (hidden by default)
    const content = document.createElement('div');
    content.className = 'bqb-onetime-content';
    
    oneTimeLevels.forEach(level => {
      content.appendChild(level);
    });
    
    // Toggle click handler
    function toggleOneTimeContent() {
      const isOpen = content.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggle.addEventListener('click', toggleOneTimeContent);
    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleOneTimeContent();
      }
    });

    // Gérer les clics sur les options subscription pour fermer l'accordéon one-time
    document.addEventListener('click', (e) => {
      if (e.target.matches('.bqb-subscriptions-wrapper input[type="radio"]') ||
          e.target.closest('.bqb-subscriptions-wrapper label')) {
        content.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    section.appendChild(toggle);
    section.appendChild(subtext);
    section.appendChild(content);
    
    return section;
  }

  function formatMoneyDisplay(text) {
    if (!text) return text;
    return String(text).replace(/(\d)\.00(\s*USD)?/g, '$1$2');
  }

  function normalizeDisplayedPrices() {
    document.querySelectorAll('.bqb-price span, .bqb-original, .bqb-onetime-toggle__text').forEach((el) => {
      el.textContent = formatMoneyDisplay(el.textContent);
    });
  }

  // Lancer l'initialisation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
